import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable, of } from "rxjs";
import { catchError, mapTo, tap } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class UserService {

  baseUrl = environment.baseUrl;
  constructor(private httpClient: HttpClient) { }

  getMyInfo(): Observable<any> {
    const _route = "user/me";
    const _url = `${this.baseUrl}${_route}`;
    return this.httpClient.get(_url);
  }

  getUsers(): Observable<any> {
    const _route = "user";
    const _url = `${this.baseUrl}${_route}`;
    return this.httpClient.get(_url).pipe();
  }

  getUserById(user_id: number | string | null): Observable<any> {
    const _route = "user";
    const _user_id = "/" + (user_id);
    const _url = `${this.baseUrl}${_route}${_user_id}`;
    return this.httpClient.get(_url);
  }

  getPagedUsers(_var: {
    page: number | null;
    page_size: number | null;
    name: string | null;
  }): Observable<any> {
    const _route = "user?";
    const _page = "page=" + (_var.page ? _var.page + 1 : 1);
    const _page_size = "&page_size=" + (_var.page_size ? _var.page_size : 20);
    const _name = _var.name ? "&name=" + _var.name : "";
    return this.httpClient.get<any>(
      `${this.baseUrl}${_route}${_page}${_page_size}${_name} `
    );
  }

} 